package com.tixforgigs.common.core.util

import com.tixforgigs.apax.models.TrackEventAction
import com.tixforgigs.apax.models.TrackEventCategory
import com.tixforgigs.apax.models.TrackRequest
import com.tixforgigs.common.CommonBuildKonfig
import io.github.oshai.kotlinlogging.KotlinLogging
import io.github.oshai.kotlinlogging.logger
import io.ktor.http.*
import web.blob.*
import web.dom.document
import web.http.BodyInit
import web.navigator.navigator
import kotlin.random.Random

actual object TrackerUtil {

  const val SITE_ID = 6

  val log by KotlinLogging.logger()

  actual suspend fun pageView() {
    log.debug { "pageView" }
    sendPing(createTrackRequest())
  }

  actual suspend fun trackEvent(category: TrackEventCategory, action: TrackEventAction, name: String) {
    sendPing(
      createTrackRequest(
        ca = 1,
        eC = category,
        eA = action,
        eN = name,
      )
    )
  }


  private suspend fun sendPing(data: TrackRequest) = navigator.sendBeacon(
    url = CommonBuildKonfig.MATOMO_URL,
    data = BodyInit(
      value = Blob(
        arrayOf(data.toFormDataContent().formData.formUrlEncode()),
        BlobPropertyBag.Companion(EndingType.native, ContentType.Application.FormUrlEncoded.toString())
      ).arrayBuffer(),
    )
  )

  private fun createTrackRequest(
    eC: TrackEventCategory? = null,
    eA: TrackEventAction? = null,
    eN: String? = null,
    ca: Int? = null,
  ) = TrackRequest(
    idsite = SITE_ID,
    apiv = 1,
    rec = 1,
    sendImage = 0,
    ca = ca,
    eC = eC,
    eA = eA,
    eN = eN,
    rand = Random.nextInt(111111, 999999),
    actionName = document.title,
    url = document.location.href
  )
}